export enum SELECT_PICKUP_POINT_EXTERNAL_SERVICES {
  listPickupPoints = 'listPickupPoints',
}
